<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
            <h1 class="text-white pt-3 px-3">
                {{$THEME.webTitle}} DROP-OFF
            </h1>
            <p class="text-white pb-0 px-3">
                แสดงข้อมูลการใช้งาน รหัส SHIPPOP และรายละเอียดการส่งด้วยระบบ {{$THEME.webTitle==='POP SHIPPOP'?'SHIPPOP':$THEME.webTitle}} ทั้งหมด
            </p>
        </div>
        <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <h1 class="display-3 text-white">
            <small>ยอดขายทั้งหมด :</small>
            {{total | numFormat('0,0.00')}}
            <small>บาท</small>
          </h1>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                  <b-form-group
                    id="input-group-1"
                    label="ค้นหาวันที่ขายสินค้า (วันเริ่มต้น - วันสุดท้าย)"
                    label-for="input-1"
                    class="mb-0"
                  >
                    <div class="row">
                      <div class="col-12 col-md-8 col-lg-8">
                        <date-range-picker
                          class="w-100"
                          :opens="'center'"
                          :singleDatePicker="false"
                          :appendToBody="true"
                          :ranges="false"
                          :closeOnEsc="false"
                          :autoApply="true"
                          :locale-data="{ format: 'dd/mm/yyyy' }"
                          v-model="filtersDate">
                        </date-range-picker>
                      </div>
                      <div class="col-12 col-md-3 col-lg-2">
                        <button class="btn btn-info btn-sm-res" v-on:click="getReport()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </b-form-group>
                  <hr class="d-md-block d-lg-none" />
                </div>

                <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                  <b-form-group
                    id="input-group-1"
                    label="ค้นหาข้อมูล"
                    label-for="input-1"
                    class="mb-0"
                  >
                    <b-form-input
                      id="input-1"
                      type="text"
                      v-model="filter"
                      placeholder="ค้นหาข้อมูล"
                    ></b-form-input>
                  </b-form-group>
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 col-xl-2">
                  <b-form-group label="Export File" class="mb-0 pb-2">
                    <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                      <vue-excel-xlsx
                        :data="formatExcel"
                        :columns="fields"
                        :filename="'สรุปข้อมูลพัสดุ Drop'+date_excel"
                        :sheetname="'สรุปข้อมูลพัสดุ Drop'+date_excel"
                        >
                        excel           
                      </vue-excel-xlsx>
                      <b-button
                        variant="info"
                        class="btn-sm-res"
                        @click="$htmlToPaper('tablePrint')"
                      >print</b-button>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                show-empty
                responsive
                :items="itemFilter"
                :fields="fields"
                :filter="filter"
                :busy="busy"
                class="scroll-bar-pop table-sticky"
                foot-clone
                >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="status" slot-scope="row">
                    <b-badge :variant="statusCourier(row.item.status).color +' report'" >
                        {{statusCourier(row.item.status).status}}
                    </b-badge>
                </template>

                 <template slot="weight" slot-scope="row">
                  {{ (row.item.weight) ? ( ( $THEME.unitKG ) ? (row.item.weight / 1000) : row.item.weight ) : '-'}}
                </template>

                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="FOOT_index">รวม</template>
                <template slot="FOOT_created_at"> &nbsp;</template>
                <template slot="FOOT_status"> &nbsp;</template>
                <template slot="FOOT_courier_name"> &nbsp;</template>
                <template slot="FOOT_barcode"> &nbsp;</template>
                <template slot="FOOT_weight"> &nbsp;</template>
                <template slot="FOOT_price">{{total == 0 ? '' : total}}</template>
                <template slot="FOOT_sender_name"> &nbsp;</template>
              </b-table>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { statusCourier } from "@/plugins/statusCourier.js"
import moment from "moment";
const API_URL = process.env.VUE_APP_API;

export default {
  name: "reportdropoffshippop",
  data() {
    return {
      orders: [],
      userLogin: "",
      busy: true,
      filter: null,
      filtersDate: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      date_excel: moment().format("DD-MM-YYYY"),
      statusCourier: statusCourier
    };
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"))
    this.getReport()
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  methods: {
    getReport() {
      this.busy = true;
      this.$http
        .post(
          API_URL + "/order/dropoff/shippop",
          {
            start: moment(this.filtersDate.startDate).format("YYYY-MM-DD"),
            end:  moment(this.filtersDate.endDate).format("YYYY-MM-DD"),
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
            this.orders = res.data.data
            this.busy = false;
        })
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
  },
  computed: {
    itemFilter() {
      return this.orders.filter(item => {
        if(!this.filter){
          return true
        }
        else if (this.filter){
        return Object.values(item).some((val)=>{
          return String(val).toLowerCase().includes(this.filter.toLowerCase())
         })
        }
      });
    },
    total() {
      return this.itemFilter.reduce((total, product) => {
        return (product.status != 'CANCEL' ) ? total + Number(product.price) : total;
      }, 0);
    },
    fields(){ 
      let fields = [
        { key: "index", field: "", label: "ลำดับ", sortable: true },
        { key: "created_at", field: "created_at", label: "วันที่นำเข้า SHOP", sortable: true , 
          dataFormat: value => {
            return (value) ? `${value}` : 'รวม';
          }
        },
        { key: "status", field: "status", label: "สถานะ", sortable: true , 
          dataFormat: value => {
            return (value) ? this.statusCourier(value).status : '';
          }
        },
        {
          key: "barcode",
          field: "barcode",
          label: "Tracking No.",
          sortable: true,
          class: "text-center"
        },
        { key: "courier_name", field: "courier_name", label: "ชื่อขนส่ง", sortable: true },
        { key: "weight", field: "weight", label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)' , sortable: true,
          dataFormat: value => {
            return (value) ? ( ( this.$THEME.unitKG ) ? `${ (value / 1000) }` : `${value}` ) : '';
          }
        },
        { key: "price", field: "price", label: "ค่าบริการ", sortable: true ,
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          }  
        },
        { key: "sender_name", field: "sender_name", label: "ชื่อผู้ส่ง", sortable: true }

      ]
      if( !this.isAdmin() && !this.isSuperAdmin() ){
          return fields.filter(function (col) {
               return [ 'index' , 'rate' , 'fee' ].indexOf(col.key) < 0

          })
      }else{
        return fields.filter(function (col) {
          return [ 'index' ].indexOf(col.key) < 0
        })
      }
    },
    formatExcel(){
      let data = [ ...this.itemFilter ];
      if(this.itemFilter.length > 0){
        let format = {
          created_at:'',
          status:'',
          barcode:'',
          courier_name:'',
          weight:'',
          price: this.total,
          sender_name:''
        }
        data.push(format);
      }
      return data;
    }
  }
};
</script>

<style></style>
